/* import __COLOCATED_TEMPLATE__ from './send-ticket-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();